import useInitialQueryParams from "../../../../../../common/ui/useInitialQueryParams";

export default function useLibraryReturnUrl() {
  const params = useInitialQueryParams();
  return params.get("library_return_url");
}
